import "./styles.less";

import React, { useEffect, useState } from "react";
import { useIsAuthModalShowing } from "../../../GlobalHooks/useIsAuthModalShowing";
import { useUser } from "../User.hook";
import { EVENT_NAME, ModalType } from "./openAuthModal";

import dynamic from "next/dynamic"
import { ReasonType } from "./models";
//@ts-ignore
const AuthModal = dynamic(() => import("./AuthModal").then(mod => mod.AuthModal), { ssr: false });



export const AuthModalProvider = () => {
	const [modalType, setModalType] = useState<ModalType>(false);
	const [fromCta, setFromCta] = useState<ModalType>(false);
	const [email, setEmail] = useState("");
	const { setIsAuthModalShowing } = useIsAuthModalShowing();
	const [reason, setReason] = useState<ReasonType>(ReasonType.unknown);
	const { user } = useUser();

	const [event, setEvent] = useState({
		accept: data => { },
		reject: () => { },
	});

	const listener = ({ detail: { accept, reject, defaultModalType, email, isFromCta, reason } }) => {
		setIsAuthModalShowing(true);
		if (!modalType) {
			setModalType(defaultModalType);
			setEvent({ accept: accept, reject: reject });
			setEmail(email);
			setFromCta(isFromCta);
			setReason(reason);
		}
	};

	useEffect(() => {
		// @ts-ignore
		window.addEventListener(EVENT_NAME, listener);
		window[EVENT_NAME] = true;

		return () => {
			// @ts-ignore
			window.removeEventListener(EVENT_NAME, listener);
			window[EVENT_NAME] = false;
		};
	}, []);

	const onCancel = () => {
		event.reject();
		setIsAuthModalShowing(false);
		setModalType(false);
	};

	const onOk = data => {
		event.accept(data);
		setIsAuthModalShowing(false);
		setModalType(false);
		user.refetch();
	};

	if (!modalType) {
		return null;
	}

	return <>{
		!!modalType && <AuthModal reason={reason} modalType={modalType} onCancel={onCancel} onOk={onOk} email={email} fromCta={fromCta} />
	}</>
};
